export const productCopy = {
    zh: {
        brandName: '观心',
        todayTitle: '今天想聊什么？',
        todaySubtitle: '把真实的事慢慢说出来，观心会陪你整理。',
        askPlaceholder: '和观心说说现在的事...',
        continueLast: '继续上次',
        talkPerson: '聊聊一个人',
        oneInsight: '看一条洞察',
        topics: '话题',
        relationships: '关系',
        memory: '记忆',
        notes: '笔记',
        insights: '洞察',
        settings: '设置',
        billing: '会员',
        privateNotes: '只给自己看的记录，不会被观心读取。',
        rememberYes: '记得对',
        rememberNo: '先不记',
    },
    en: {
        brandName: 'Mira',
        slogan: 'See Within',
        todayTitle: 'What would you like to talk through?',
        todaySubtitle: 'Start with the real situation. Mira will help you sort it gently.',
        askPlaceholder: 'Ask Mira anything...',
        continueLast: 'Continue last',
        talkPerson: 'Talk about someone',
        oneInsight: 'Review one insight',
        topics: 'Topics',
        relationships: 'Relationships',
        memory: 'Memory',
        notes: 'Notes',
        insights: 'Insights',
        settings: 'Settings',
        billing: 'Billing',
        privateNotes: 'Private notes stay yours and are not read by Mira.',
        rememberYes: 'Keep this',
        rememberNo: 'Not now',
    },
};
